import Service from "../../service";

const MembersSettingService = {
  CreateCatagoryType: async (data, token) => {
    try {
      return await Service.post({
        url: `/setting/v1/member/category`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  getCatagoryTypesList: async (token) => {
    try {
      return await Service.get(`/setting/v1/member/category`, token);
    } catch (error) {
      throw error;
    }
  },
  searchCategoryTypes: async (search, token) => {
    try {
      return await Service.get(
        `/setting/v1/member/category?search=${search}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },
  getCatagoryListByType: async (type, token, search) => {
    try {
      return await Service.get(
        `/setting/v1/member/category?${type ? `type=${type}` : ""}&${search ? `search=${search}` : ""}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },
  getCatagoryTypesById: async (id, token) => {
    try {
      return await Service.get(`/setting/v1/member/category/${id}`, token);
    } catch (error) {
      throw error;
    }
  },
  deleteCatagoryTypesById: (token, id) => {
    try {
      return Service.remove({
        url: `/setting/v1/member/category/${id}`,
        token,
      });
    } catch (err) {
      throw err;
    }
  },
  updateCategoryTypesById: (id, data, token) => {
    return Service.update({
      url: `/setting/v1/member/category/${id}`,
      data,
      token,
    });
  },
  // get Dropdown Options
  getDropdownOptions: async ({token}) => {
    try {
      return await Service.get(
        `/setting/v1/member/options`,
        token
      );
    } catch (error) {
      throw error;
    }
  },
  // Update Dropdown Options
  updateDropdownOptions: ({token,data}) => {
    return Service.update({
      url: `/setting/v1/member/options/org`,
      data,
      token,
    });
  },
  //   getLedgerSubLedgerList: async (token) => {
  //     try {
  //       return await Service.get(`/setting/v1/finance/ledger/list`, token);
  //     } catch (error) {
  //       throw error;
  //     }
  //   },
  //   searchLedgerByName: async (search, token) => {
  //     try {
  //       return await Service.get(
  //         `/setting/v1/finance/ledger/list?search=${search}`,
  //         token
  //       );
  //     } catch (error) {
  //       throw error;
  //     }
  //   },
  //   getLedgerSubLedgerById: async (type, id, token) => {
  //     try {
  //       return await Service.get(
  //         `/setting/v1/finance/ledger?type=${type}&id=${id}`,
  //         token
  //       );
  //     } catch (error) {
  //       throw error;
  //     }
  //   },

  //   createNewLedgerSubledger: async (data, token) => {
  //     try {
  //       return await Service.post({
  //         url: `/setting/v1/finance/ledger`,
  //         data,
  //         token,
  //       });
  //     } catch (error) {
  //       throw error;
  //     }
  //   },

  //   createNewReversalType: async (data, token) => {
  //     try {
  //       return await Service.post({
  //         url: `/setting/v1/finance/reversal`,
  //         data,
  //         token,
  //       });
  //     } catch (error) {
  //       throw error;
  //     }
  //   },
  //   deleteReversalById: (token, id) => {
  //     try {
  //       return Service.remove({
  //         url: `/setting/v1/finance/reversal/${id}`,
  //         token,
  //       });
  //     } catch (err) {
  //       throw err;
  //     }
  //   },
  //   deleteLedgerSubledgerById: (token, type, id) => {
  //     try {
  //       return Service.remove({
  //         url: `/setting/v1/finance/ledger?type=${type}&id=${id}`,
  //         token,
  //       });
  //     } catch (err) {
  //       throw err;
  //     }
  //   },
};

export default MembersSettingService;
